module.exports = __webpack_public_path__ + "img/gys_5@2x.f05a31f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_5@2x.png
// module id = T98o
// module chunks = 0